export default "__VITE_ASSET__CF4jXcGy__"